<template>
  <div>
    <RouterView name="default" :content="allCases"></RouterView>
    <transition name="fade">
      <RouterView class="case_page_container" name="case_page" :content="allCases"></RouterView>
    </transition>
    <RouterView name="footer"></RouterView>
  </div>
</template>

<script>
import i18n from '@/mixins/i18n'

export default {
  name: 'App',
  mixins: [i18n],
  props: {
    locale: {
      type: String,
      default: null
    }
  },
  beforeMount () {
    this.setLocale(this.locale)
  },
  beforeRouteUpdate (to, from, next) {
    this.setLocale(to.params.locale)
    next()
  },
  computed: {
    allCases() {
      return require(`../data/${this.locale}/cases.json`)
    }
  },
  methods: {
    hasContentOverlays () {
      return this.$store.state.contentOverlays.counter > 0
    },
    activePage() {
      if(this.$route.params.url_case) {
        return `active_page`
      }

      return `inactive_page`
    },
    scrollCredits() {
      const triggers = document.getElementById('credits-container')
      
      if((window.scrollY+window.innerHeight*.8) > triggers.offsetTop) {
        document.querySelector('.thumb_navigation').style.bottom = `-300px`
      } else {
        document.querySelector('.thumb_navigation').style.bottom = `0`
      }

      
      
      // Array.from(triggers).forEach((i)=> {
      //   if(i.dataset.section != this.activateSection) {
      //     const scrollY = window.scrollY + (window.innerHeight * .7)
      //     const top = i.offsetTop

      //     if( top <= scrollY && (top+ i.offsetHeight) >= scrollY) {

      //       // trigger for scrolldown
            
      //       if(i.dataset.analytics) {
      //         if(!this.eventsFired.includes(i.dataset.analytics)) {
      //           console.log(i.dataset.scroll)
      //           window.dataLayer.push({
      //             event: `section_${i.dataset.scroll}_percent`,
      //             widget_pos: 1,
      //             section_category: i.dataset.analytics,
      //             content_type: "univisionarios",
      //           })
      //           this.eventsFired.push(i.dataset.analytics)
      //         }
      //       }
      //     }
      //   }
      // })
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.scrollCredits()
    })
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  max-width: 1220px !important;
}

.fade-enter {
  transition: 0;
  background-color: #000;
}

.fade-enter-active {
  transition: opacity 2s ease;
  background-color: #000;
}

.fade-leave {
  transition: opacity 2s ease;
  opacity: 0;
}

.fade-leave-active {
  transition: opacity 3s ease;
  opacity: 0;
}

.case_page_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: var(--app-bg);
}

h4 {
  color: var(--app-color-red);
}
</style>
